<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div v-if="receipt.length > 0">

      <!-- Table Container Card -->
      <b-card
          class="mb-0"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>

            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="6"
            >
              <h2>اطلاعات کاربر ثبت کننده فیش</h2>
              <span v-if="!receipt[0].shoppingForAnotherPerson" class="ml-1">(فیش را برای خودش ثبت کرده)</span>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            :fields="userSubmit"
            :items="receipt"
            breceipted
            class="position-relative"
            empty-text="موردی موجود نیست!"
            responsive
            show-empty
            striped
        >
        </b-table>
      </b-card>

      <!-- Table Container Card -->
      <b-card
          v-if="receipt[0].shoppingForAnotherPerson"
          class="mt-3"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="6"
            >
              <h2>اطلاعات کاربری که فیش برایش ثبت شده</h2>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            :fields="affectedUser"
            :items="receipt"
            breceipted
            class="position-relative"
            empty-text="موردی موجود نیست!"
            primary-key="id"
            responsive
            show-empty
            striped
        >
          <!-- Column: doseUserExist -->
          <template #cell(doseUserExist)="data">
            <span v-if="data.item.doseUserExist" class="text-success">عضو رها مزون</span>
            <b-button
                v-else
                :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                variant="primary"
                @click="makeAccount"
            >
              ساخت اکانت
            </b-button>
          </template>
        </b-table>
      </b-card>

      <b-card
          class="mt-3"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="6"
            >
              <h2>اطلاعات کلی فیش</h2>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            :fields="myTableColumnsType"
            :items="receipt"
            breceipted
            class="position-relative"
            empty-text="موردی موجود نیست!"
            primary-key="id"
            responsive
            show-empty
            striped
        >

          <template #cell(sumPrice)="data">
            <span v-if="data.item.sumPriceAfterDiscount">
               {{ makePrettyPrice(data.item.sumPriceAfterDiscount) }} تومان
            </span>
            <span v-else>
               {{ makePrettyPrice(data.item.sumPrice) }} تومان
            </span>
          </template>

          <!-- Column: createDate -->
          <template #cell(createDate)="data">
            <span>
              {{ createJalaliDate(data.item.createDate) }}
            </span>
          </template>

          <template #cell(status)="data">
            <span v-if="data.item.status === 1">در صف انتظار</span>
            <span v-if="data.item.status === 2" class="text-danger">رد شده</span>
            <span v-if="data.item.status === 3">تایید شده</span>
            <span v-if="data.item.status === 4" class="text-success">تایید شده توسط حسابدار</span>
          </template>

        </b-table>
        <b-row class="p-1">
          <b-col cols="12" md="3">
            <strong>
              از کیف پول استفاده
              <span class="text-success" v-if="receipt.usingWalletCredit">شده</span>
              <span class="text-danger" v-else>نشده</span>
            </strong>
          </b-col>
        </b-row>
        <b-row class="p-1">
          <b-col cols="12" md="3">
            <strong>
              کد کوپن :
              <span class="text-success" v-if="receipt.couponId">{{ receipt.couponId }}</span>
              <span class="text-danger" v-else>استفاده نشده</span>
            </strong>
          </b-col>
        </b-row>
      </b-card>

      <b-card
          class="mt-3"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="6"
            >
              <h2>اطلاعات واریزها</h2>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            :fields="receiptsTable"
            :items="receipt[0].detailes"
            breceipted
            class="position-relative"
            empty-text="موردی موجود نیست!"
            primary-key="id"
            responsive
            show-empty
            striped
        >

          <template #cell(mainImage)="data">
            <b-media vertical-align="center">
              <template #aside>
                <img
                    style="max-height: 500px"
                    :src="baseUrl+data.item.mainImage"
                />
              </template>
            </b-media>
          </template>

          <template #cell(price)="data">
            <span>
               {{ makePrettyPrice(data.item.price) }} تومان
            </span>
          </template>

          <!-- Column: paymentDate -->
          <template #cell(paymentDate)="data">
            <span>
              {{ createJalaliDate(data.item.paymentDate) }}
            </span>
          </template>

          <template #cell(status)="data">
            <span v-if="data.item.status === 1">در صف انتظار</span>
            <span v-if="data.item.status === 2" class="text-danger">رد شده</span>
            <span v-if="data.item.status === 3">تایید شده</span>
            <span v-if="data.item.status === 4" class="text-success">تایید شده توسط حسابدار</span>
          </template>

          <template #cell(edit)="data">

            <div v-b-modal.modal-edit @click="showModal(data.item)" class="text-primary cursor-pointer">
              <feather-icon icon="EditIcon" size="20"/>
            </div>

          </template>

        </b-table>
      </b-card>

      <b-card
          class="mt-3"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
                md="6"
            >
              <h2>اطلاعات ادمین هایی که تغییر وضعیت این فیش را انجام داده‌اند</h2>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            :fields="responsibles"
            :items="logs"
            breceipted
            class="position-relative"
            empty-text="موردی موجود نیست!"
            primary-key="id"
            responsive
            show-empty
            striped
        >

          <template #cell(mainImage)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    :src="baseUrl+data.item.mainImage"
                    size="500"
                    rounded
                />
              </template>
            </b-media>
          </template>

          <template #cell(price)="data">
            <span>
               {{ makePrettyPrice(data.item.price) }} تومان
            </span>
          </template>

          <!-- Column: createDate -->
          <template #cell(createDate)="data">
            <span>
              {{ createJalaliDate(data.item.createDate) }}
            </span>
          </template>

          <template #cell(status)="data">
            <span v-if="data.item.status === 1">در صف انتظار</span>
            <span v-if="data.item.status === 2" class="text-danger">رد شده</span>
            <span v-if="data.item.status === 3">تایید شده</span>
            <span v-if="data.item.status === 4" class="text-success">تایید شده توسط حسابدار</span>
          </template>

        </b-table>
      </b-card>

      <b-card
          class="mt-3"
          no-body
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                cols="12"
            >
              <h2>تعیین وضعیت فیش</h2>
            </b-col>
            <b-row>
              <b-col
                  cols="12"
                  class="mt-50"
              >
                <b-button
                    variant="success"
                    class="mr-1 mt-2"
                    @click="confirmByAdmin"
                >
                  تایید (توسط سوپر ادمین اصلی)
                </b-button>

                <b-button
                    variant="primary"
                    class="mr-1 mt-2"
                    @click="confirmByAccount"
                >
                  تایید (توسط حسابدار)
                </b-button>

                <b-button
                    variant="warning"
                    class="mr-1 mt-2"
                    v-b-modal.modal-delete
                >
                  رد
                </b-button>
              </b-col>
              <b-col
                  cols="12"
                  class="mt-50"
              >
                <b-button
                    variant="danger"
                    class="mr-1 mt-2"
                    @click="deleteReceipt"
                >
                  <feather-icon icon="TrashIcon" class="text-white" size="15"/>
                  حذف فیش
                </b-button>
              </b-col>
            </b-row>
          </b-row>
        </div>
      </b-card>
    </div>

    <b-modal
        id="modal-delete"
        centered
        title="رد کردن فیش"
        ok-title="رد کردن فیش"
        cancelTitle="انصراف"
        @ok="rejectReceipt"
    >
      <b-form-group
          label="توضیحات"
          label-for="seoDescription"
      >
        <b-form-textarea
            id="seoDescription"
            v-model="description"
        ></b-form-textarea>
      </b-form-group>
    </b-modal>

    <b-modal
        v-if="selectedToEdit"
        id="modal-edit"
        centered
        title="ویرایش فیش"
        ok-title="ثبت"
        cancelTitle="انصراف"
        @ok="updateReceipt"
    >
      <b-form-group
          label="4 رقم آخر کارت"
          label-for="last4CardNumber"
      >
        <b-form-input
            id="last4CardNumber"
            v-model="selectedToEdit.last4CardNumber"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          label="کد پیگیری"
          label-for="trackingCode"
      >
        <b-form-input
            id="trackingCode"
            v-model="selectedToEdit.trackingCode"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          label="مبلغ واریز"
          label-for="price"
      >
        <b-form-input
            id="price"
            v-model="selectedToEdit.price"
        ></b-form-input>
      </b-form-group>
      <b-form-group
          label="تاریخ واریز"
          label-for="paymentDate"
      >
        <b-form-input
            id="paymentDate"
            :value="createJalaliDate(selectedToEdit.paymentDate)"
        ></b-form-input>
        <date-picker
            v-model="selectedToEdit.paymentDate"
            element="paymentDate"
            class="direction-ltr"
            color="#5c6bc0"
            display-format="jYYYY/jMM/jDD HH:mm"
            format="YYYY-MM-DD HH:mm"
            input-format="YYYY-MM-DD HH:mm"
            type="datetime"
        />
      </b-form-group>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormInput, BFormTextarea,
  BMedia, BModal,
  BOverlay,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import Helper from "@/libs/Helper";
import {
  PaymentReceiptAccountConfirmeRequest,
  PaymentReceiptConfirmeRequest,
  PaymentReceiptCreateUserRequest,
  PaymentReceiptDeleteRequest,
  PaymentReceiptGetByIdRequest,
  PaymentReceiptLogRequest,
  PaymentReceiptRejectRequest,
  PaymentReceiptUpdatePaymentReceiptDetaileRequest
} from "@/libs/Api/PaymentReciept";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  title: "اطلاعات سفارش - پنل ادمین رها مزون",
  name: "receiptInfo",
  data() {
    return {
      receipt: [],
      baseUrl:Helper.baseUrl,
      receiptId: this.$route.params.id,
      showOverlay: false,
      description:'',
      userSubmit: [
        {key: 'user.name', label: 'نام'},
        {key: 'user.familyName', label: 'نام خانوادگی'},
        {key: 'user.mobile', label: 'موبایل'},
        {key: 'user.nationalId', label: 'کد ملی'},
      ],
      affectedUser: [
        {key: 'anotherPersonFullName', label: 'نام کامل'},
        {key: 'anotherPersonPhoneNumber', label: 'موبایل'},
        {key: 'anotherPersonInstagramId', label: 'اینستاگرام'},
        {key: 'anotherPersonNationalId', label: 'کد ملی'},
        {key: 'doseUserExist', label: 'عضویت کاربر'},
      ],
      myTableColumnsType: [
        {key: 'id', label: 'شناسه فیش'},
        {key: 'sumPrice', label: 'مبلغ سفارش'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'status', label: 'وضعیت'},
      ],
      receiptsTable: [
        {key: 'mainImage', label: 'تصویر'},
        {key: 'last4CardNumber', label: '4 رقم آخر'},
        {key: 'trackingCode', label: 'کد پیگیری'},
        {key: 'price', label: 'مبلغ واریز'},
        {key: 'paymentDate', label: 'تاریخ واریز'},
        {key: 'edit', label: 'ویرایش'},
      ],
      responsibles:[
        {key: 'userFullName', label: 'نام کامل'},
        {key: 'createDate', label: 'تاریخ ثبت'},
        {key: 'status', label: 'تغییرات'},
        {key: 'description', label: 'توضیحات'},
      ],
      logs:[],
      selectedToEdit:null,
    }
  },
  async created() {
    await this.getReceipt();
  },
  methods: {
    async getReceipt() {
      let _this = this;
      _this.showOverlay = true

      let paymentReceiptGetByIdRequest = new PaymentReceiptGetByIdRequest(_this);
      paymentReceiptGetByIdRequest.setParams({id: _this.receiptId});
      await paymentReceiptGetByIdRequest.fetch(function (content) {
        _this.receipt = content;
        _this.showOverlay = false;
        _this.getReceiptLogs();
      }, function (error) {
        _this.showOverlay = false
      })
    },
    async getReceiptLogs() {
      let _this = this;
      _this.showOverlay = true

      let paymentReceiptLogRequest = new PaymentReceiptLogRequest(_this);
      paymentReceiptLogRequest.setParams({paymentReceiptId: _this.receiptId});
      await paymentReceiptLogRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.logs = content.data;
      }, function (error) {
        _this.showOverlay = false
      })
    },
    async confirmByAdmin() {
      let _this = this;
      _this.showOverlay = true;

      let paymentReceiptConfirmeRequest = new PaymentReceiptConfirmeRequest(_this);
      paymentReceiptConfirmeRequest.setParams({id: _this.receiptId});
      await paymentReceiptConfirmeRequest.fetch(function (content) {
        _this.showOverlay = false;
        if (content.isSuccess) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `فیش تایید شد.`,
            },
          });
          _this.getReceipt();
        } else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CheckIcon',
              variant: 'danger',
              text: content.errorMessage,
            },
          })
        }
      }, function (error) {
        _this.showOverlay = false
      })
    },
    async confirmByAccount() {
      let _this = this;
      _this.showOverlay = true;

      let paymentReceiptAccountConfirmeRequest = new PaymentReceiptAccountConfirmeRequest(_this);
      paymentReceiptAccountConfirmeRequest.setParams({id: _this.receiptId});
      await paymentReceiptAccountConfirmeRequest.fetch(function (content) {
        _this.showOverlay = false;
        if (content.isSuccess) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `فیش تایید شد.`,
            },
          });
          _this.getReceipt();
        } else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CheckIcon',
              variant: 'danger',
              text: content.errorMessage,
            },
          })
        }
      }, function (error) {
        _this.showOverlay = false
      })
    },
    async updateReceipt(){
      let _this = this;
      _this.overlay = true;

      let paymentReceiptUpdatePaymentReceiptDetaileRequest = new PaymentReceiptUpdatePaymentReceiptDetaileRequest(_this);
      paymentReceiptUpdatePaymentReceiptDetaileRequest.setParams(_this.selectedToEdit);
      await paymentReceiptUpdatePaymentReceiptDetaileRequest.fetch(function (content){
        if (content.isSuccess){
          _this.overlay = false;
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `اطلاعات فیش ویرایش شد.`,
            },
          })
          _this.getReceipt();
        }else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              variant: 'danger',
              text: content.errorMessage,
            },
          })
        }
        _this.selectedToEdit = null;
      },function (error){
        _this.overlay = false;
      })
    },
    showModal(data){
      this.selectedToEdit = data;
    },
    async rejectReceipt() {
      let _this = this;
      _this.showOverlay = true;

      let data = {
        id: _this.receiptId,
        description:_this.description
      }

      let paymentReceiptRejectRequest = new PaymentReceiptRejectRequest(_this);
      paymentReceiptRejectRequest.setParams(data);
      await paymentReceiptRejectRequest.fetch(function (content) {
        _this.showOverlay = false;
        if (content.isSuccess) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `فیش رد شد.`,
            },
          });
          _this.getReceipt();
        } else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CheckIcon',
              variant: 'danger',
              text: content.errorMessage,
            },
          })
        }
      }, function (error) {
        _this.showOverlay = false
      })
    },
    async makeAccount() {
      let _this = this;
      _this.showOverlay = true;

      let paymentReceiptCreateUserRequest = new PaymentReceiptCreateUserRequest(_this);
      paymentReceiptCreateUserRequest.setParams({id: _this.receiptId});
      await paymentReceiptCreateUserRequest.fetch(function (content) {
        _this.showOverlay = false;
        if (content.isSuccess) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `اکانت کاربر ساخته شد.`,
            },
          });
          _this.getReceipt();
        } else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CheckIcon',
              variant: 'danger',
              text: content.errorMessage,
            },
          })
        }
      }, function (error) {
        _this.showOverlay = false
      })
    },
    async deleteReceipt(){
      let _this = this;
      _this.overlay = true;

      let paymentReceiptDeleteRequest = new PaymentReceiptDeleteRequest(_this);
      paymentReceiptDeleteRequest.setParams({id:_this.receiptId});
      await paymentReceiptDeleteRequest.fetch(function (content){
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `فیش حذف شد.`,
          },
        })
        _this.$router.back();
      },function (error){
        _this.overlay = false;
      })
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      if (param !== null && param !== '') {
        return param.slice(11, 16) + ' - ' + new Date(param.slice(0, 10)).toLocaleDateString("fa-IR",);
      }
    },
  },
  components: {
    BFormGroup, BFormTextarea,
    BModal,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    vSelect,
  }
  ,
}
</script>

<style scoped>

</style>
